export const N76_05 = {
    "columns": 4,
    "rows": 1,
    "visual": {
        "id": 4,
        "type": "radialBar2",
        "colorTheme": 'colorTheme2',
        "title": "Sales VS Collection",
        "xAxis": "",
        "yAxis": "",
        "orientation": "",
        "binding": {
            "data": {
                "series": [
                    {
                        "name": 'Sales',
                        "value": 'ActualSales'
                    },
                    {
                        "name": 'Collection',
                        "value": 'Collection'
                    }
                ],
                "maxValue": "ActualSales",
                "endpoint": "N76.5",
                "parameters": [
                    { "key": "FromMonth", "value": "" },
                    { "key": "FromYear", "value": "" },
                    { "key": "ToMonth", "value": "" },
                    { "key": "ToYear", "value": "" },
                    { "key": "ConfigTypeCode", "value": "" }
                ]
            },
            "context": {
                "point": {
                    "onClick": {}
                }
            }
        }
    }
}